import React from "react";
import JobTypeCardRouter from "./JobTypeCardRouter";

export default function GreenspaceJob({ job, company }) {
  return (
    <div className="mx-auto max-w-4xl px-4 py-6">
      {/* Header */}
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold text-gray-900">
          Greenspace job
        </h1>
        <p className="text-sm text-gray-500">
          {company?.name || job.companyName || "—"}
        </p>
      </div>

      {/* Basic details */}
      <div className="mt-4 rounded-xl border border-gray-200 bg-white shadow-sm p-4">
        <h2 classatulay="text-base font-semibold text-gray-800 mb-2">
          Job details
        </h2>

        <div className="text-sm text-gray-700 space-y-1">
          <div>
            <span className="font-medium text-gray-800">Address:</span>{" "}
            {job.address?.line1 || job.address || "—"}
          </div>
        </div>
      </div>

      {/* Job type card router */}
      <div className="mt-6">
        <JobTypeCardRouter job={job} company={company} />
      </div>
    </div>
  );
}
